export const californiaLocations = {
  'los-angeles': {
    name: 'Los Angeles',
    state: 'CA',
    title: 'Pet Insurance Los Angeles CA - Nationwide Coverage',
    metaDescription: 'Get pet insurance in Los Angeles, CA. Protect your dog, cat, or exotic pet with Nationwide coverage. Serving Beverly Hills, Santa Monica, Hollywood & all LA County.',
    landmarks: ['Hollywood Sign', 'Griffith Observatory', 'Santa Monica Pier', 'Beverly Hills', 'Venice Beach'],
    veterinaryClinics: ['VCA West Los Angeles Animal Hospital', 'BluePearl Pet Hospital', 'Animal Specialty Group'],
    averageCosts: {
      dog: 75,
      cat: 45,
      exotic: 55
    },
    subCities: [
      {
        slug: 'beverly-hills',
        name: 'Beverly Hills',
        title: 'Pet Insurance Beverly Hills CA - Luxury Pet Care Coverage',
        landmarks: ['Rodeo Drive', 'Beverly Hills Hotel', 'Greystone Mansion']
      },
      {
        slug: 'santa-monica',
        name: 'Santa Monica',
        title: 'Pet Insurance Santa Monica CA - Beach City Pet Protection',
        landmarks: ['Santa Monica Pier', 'Third Street Promenade', 'Venice Beach']
      },
      {
        slug: 'hollywood',
        name: 'Hollywood',
        title: 'Pet Insurance Hollywood CA - Entertainment District Coverage',
        landmarks: ['Hollywood Walk of Fame', 'TCL Chinese Theatre', 'Hollywood Bowl']
      },
      {
        slug: 'pasadena',
        name: 'Pasadena',
        title: 'Pet Insurance Pasadena CA - Rose City Pet Care',
        landmarks: ['Rose Bowl', 'Huntington Library', 'Old Town Pasadena']
      },
      {
        slug: 'long-beach',
        name: 'Long Beach',
        title: 'Pet Insurance Long Beach CA - Port City Pet Protection',
        landmarks: ['Queen Mary', 'Aquarium of the Pacific', 'Long Beach Harbor']
      },
      {
        slug: 'glendale',
        name: 'Glendale',
        title: 'Pet Insurance Glendale CA - Valley Pet Care Coverage',
        landmarks: ['Brand Boulevard', 'Americana at Brand', 'Forest Lawn Cemetery']
      }
    ]
  },
  'san-francisco': {
    name: 'San Francisco',
    state: 'CA',
    title: 'Pet Insurance San Francisco CA - Bay Area Pet Coverage',
    metaDescription: 'Pet insurance in San Francisco, CA. Nationwide coverage for dogs, cats & exotic pets. Serving Oakland, Berkeley, Daly City & all Bay Area.',
    landmarks: ['Golden Gate Bridge', 'Alcatraz Island', 'Lombard Street', 'Fishermans Wharf', 'Coit Tower'],
    veterinaryClinics: ['UCSF Veterinary Medical Center', 'VCA San Francisco Veterinary Specialists', 'Pet Emergency Treatment Service'],
    averageCosts: {
      dog: 85,
      cat: 50,
      exotic: 65
    },
    subCities: [
      {
        slug: 'oakland',
        name: 'Oakland',
        title: 'Pet Insurance Oakland CA - East Bay Pet Protection',
        landmarks: ['Lake Merritt', 'Jack London Square', 'Oakland Coliseum']
      },
      {
        slug: 'berkeley',
        name: 'Berkeley',
        title: 'Pet Insurance Berkeley CA - University City Pet Care',
        landmarks: ['UC Berkeley Campus', 'Telegraph Avenue', 'Berkeley Hills']
      },
      {
        slug: 'daly-city',
        name: 'Daly City',
        title: 'Pet Insurance Daly City CA - Peninsula Pet Coverage',
        landmarks: ['Cow Palace', 'Westlake District', 'San Bruno Mountain']
      },
      {
        slug: 'san-mateo',
        name: 'San Mateo',
        title: 'Pet Insurance San Mateo CA - Peninsula Pet Care',
        landmarks: ['Hillsdale Mall', 'Central Park', 'Borel Estate']
      },
      {
        slug: 'fremont',
        name: 'Fremont',
        title: 'Pet Insurance Fremont CA - East Bay Pet Protection',
        landmarks: ['Ardenwood Historic Farm', 'Central Park', 'Lake Elizabeth']
      },
      {
        slug: 'hayward',
        name: 'Hayward',
        title: 'Pet Insurance Hayward CA - East Bay Pet Coverage',
        landmarks: ['Hayward Regional Shoreline', 'Kennedy Park', 'Southland Mall']
      }
    ]
  },
  'san-diego': {
    name: 'San Diego',
    state: 'CA',
    title: 'Pet Insurance San Diego CA - Americas Finest City Pet Care',
    metaDescription: 'Pet insurance in San Diego, CA. Nationwide coverage for all pets. Serving Chula Vista, Carlsbad, Oceanside & all San Diego County.',
    landmarks: ['Balboa Park', 'San Diego Zoo', 'Sunset Cliffs', 'Gaslamp Quarter', 'Mission Beach'],
    veterinaryClinics: ['VCA Emergency Animal Hospital', 'BluePearl Pet Hospital', 'Animal Emergency Clinic'],
    averageCosts: {
      dog: 70,
      cat: 42,
      exotic: 52
    },
    subCities: [
      {
        slug: 'chula-vista',
        name: 'Chula Vista',
        title: 'Pet Insurance Chula Vista CA - South Bay Pet Protection',
        landmarks: ['Chula Vista Marina', 'Otay Valley Regional Park', 'Olympic Training Center']
      },
      {
        slug: 'oceanside',
        name: 'Oceanside',
        title: 'Pet Insurance Oceanside CA - North County Coastal Pet Care',
        landmarks: ['Oceanside Pier', 'Camp Pendleton', 'Mission San Luis Rey']
      },
      {
        slug: 'escondido',
        name: 'Escondido',
        title: 'Pet Insurance Escondido CA - North County Inland Pet Coverage',
        landmarks: ['San Diego Zoo Safari Park', 'Daley Ranch', 'California Center for the Arts']
      },
      {
        slug: 'carlsbad',
        name: 'Carlsbad',
        title: 'Pet Insurance Carlsbad CA - Flower Fields Pet Protection',
        landmarks: ['Flower Fields', 'Legoland California', 'Carlsbad State Beach']
      },
      {
        slug: 'el-cajon',
        name: 'El Cajon',
        title: 'Pet Insurance El Cajon CA - East County Pet Care',
        landmarks: ['Parkway Plaza', 'Wells Park', 'Sycuan Casino']
      },
      {
        slug: 'vista',
        name: 'Vista',
        title: 'Pet Insurance Vista CA - North County Pet Coverage',
        landmarks: ['Brengle Terrace Park', 'Alta Vista Gardens', 'Moonlight Amphitheatre']
      }
    ]
  },
  'sacramento': {
    name: 'Sacramento',
    state: 'CA',
    title: 'Pet Insurance Sacramento CA - Capital City Pet Coverage',
    metaDescription: 'Pet insurance in Sacramento, CA. Nationwide coverage for dogs, cats & exotic pets. Serving Elk Grove, Roseville, Folsom & all Sacramento County.',
    landmarks: ['State Capitol Building', 'Old Sacramento', 'American River', 'Crocker Art Museum', 'Tower Bridge'],
    veterinaryClinics: ['VCA Sacramento Veterinary Referral Center', 'UC Davis Veterinary Medical Teaching Hospital', 'Pet Emergency & Specialty Center'],
    averageCosts: {
      dog: 60,
      cat: 35,
      exotic: 45
    },
    subCities: [
      {
        slug: 'elk-grove',
        name: 'Elk Grove',
        title: 'Pet Insurance Elk Grove CA - South Sacramento Pet Protection',
        landmarks: ['Elk Grove Regional Park', 'Strauss Festival', 'Laguna Creek']
      },
      {
        slug: 'roseville',
        name: 'Roseville',
        title: 'Pet Insurance Roseville CA - Placer County Pet Care',
        landmarks: ['Westfield Galleria', 'Maidu Regional Park', 'Historic Old Town']
      },
      {
        slug: 'folsom',
        name: 'Folsom',
        title: 'Pet Insurance Folsom CA - Gold Country Pet Coverage',
        landmarks: ['Folsom Prison', 'Folsom Lake', 'Historic Folsom District']
      },
      {
        slug: 'citrus-heights',
        name: 'Citrus Heights',
        title: 'Pet Insurance Citrus Heights CA - Northeast Sacramento Pet Care',
        landmarks: ['Sunrise Mall', 'Rusch Botanical Gardens', 'Tempo Park']
      },
      {
        slug: 'rancho-cordova',
        name: 'Rancho Cordova',
        title: 'Pet Insurance Rancho Cordova CA - Gold River Pet Protection',
        landmarks: ['American River Parkway', 'Hagan Community Park', 'Mills Station']
      },
      {
        slug: 'davis',
        name: 'Davis',
        title: 'Pet Insurance Davis CA - University Town Pet Coverage',
        landmarks: ['UC Davis Campus', 'Davis Farmers Market', 'Central Park']
      }
    ]
  },
  'san-jose': {
    name: 'San Jose',
    state: 'CA',
    title: 'Pet Insurance San Jose CA - Silicon Valley Pet Coverage',
    metaDescription: 'Pet insurance in San Jose, CA. Nationwide coverage for tech city pets. Serving Sunnyvale, Santa Clara, Milpitas & all Silicon Valley.',
    landmarks: ['Winchester Mystery House', 'San Jose Museum of Art', 'Santana Row', 'SAP Center', 'Alum Rock Park'],
    veterinaryClinics: ['VCA Animal Care Center', 'Adobe Animal Hospital', 'Emergency Animal Clinic of South San Jose'],
    averageCosts: {
      dog: 80,
      cat: 48,
      exotic: 60
    },
    subCities: [
      {
        slug: 'sunnyvale',
        name: 'Sunnyvale',
        title: 'Pet Insurance Sunnyvale CA - Tech Hub Pet Protection',
        landmarks: ['Baylands Park', 'Downtown Sunnyvale', 'Las Palmas Park']
      },
      {
        slug: 'santa-clara',
        name: 'Santa Clara',
        title: 'Pet Insurance Santa Clara CA - Mission City Pet Care',
        landmarks: ['Mission Santa Clara', 'Levis Stadium', 'California\'s Great America']
      },
      {
        slug: 'milpitas',
        name: 'Milpitas',
        title: 'Pet Insurance Milpitas CA - South Bay Pet Coverage',
        landmarks: ['Great Mall', 'Ed R. Levin County Park', 'Milpitas Sports Center']
      },
      {
        slug: 'cupertino',
        name: 'Cupertino',
        title: 'Pet Insurance Cupertino CA - Apple City Pet Protection',
        landmarks: ['Apple Park', 'Cupertino Library', 'Rancho San Antonio']
      },
      {
        slug: 'mountain-view',
        name: 'Mountain View',
        title: 'Pet Insurance Mountain View CA - Google Town Pet Care',
        landmarks: ['Googleplex', 'Shoreline Amphitheatre', 'Computer History Museum']
      },
      {
        slug: 'palo-alto',
        name: 'Palo Alto',
        title: 'Pet Insurance Palo Alto CA - Stanford Pet Coverage',
        landmarks: ['Stanford University', 'Palo Alto Baylands', 'University Avenue']
      }
    ]
  },
  'fresno': {
    name: 'Fresno',
    state: 'CA',
    title: 'Pet Insurance Fresno CA - Central Valley Pet Coverage',
    metaDescription: 'Pet insurance in Fresno, CA. Nationwide coverage for Central Valley pets. Serving Clovis, Madera, Selma & all Fresno County.',
    landmarks: ['Forestiere Underground Gardens', 'Fresno Chaffee Zoo', 'Tower District', 'Woodward Park', 'Fresno Art Museum'],
    veterinaryClinics: ['VCA Valley Animal Medical Center', 'Pet Emergency & Specialty Center', 'Animal Medical Center'],
    averageCosts: {
      dog: 55,
      cat: 32,
      exotic: 40
    },
    subCities: [
      {
        slug: 'clovis',
        name: 'Clovis',
        title: 'Pet Insurance Clovis CA - Gateway to Sierra Pet Protection',
        landmarks: ['Old Town Clovis', 'Clovis Botanical Garden', 'Sierra National Forest']
      },
      {
        slug: 'madera',
        name: 'Madera',
        title: 'Pet Insurance Madera CA - Central Valley Pet Care',
        landmarks: ['Madera Wine Trail', 'Fossil Discovery Center', 'Lions Town & Country Park']
      },
      {
        slug: 'selma',
        name: 'Selma',
        title: 'Pet Insurance Selma CA - Raisin Capital Pet Coverage',
        landmarks: ['Selma Pioneer Village', 'Selma Arts Center', 'Floral Park']
      },
      {
        slug: 'reedley',
        name: 'Reedley',
        title: 'Pet Insurance Reedley CA - World\'s Fruit Basket Pet Protection',
        landmarks: ['Reedley Beach', 'Mennonite Quilt Center', 'Kings River']
      },
      {
        slug: 'sanger',
        name: 'Sanger',
        title: 'Pet Insurance Sanger CA - Blossom Trail Pet Care',
        landmarks: ['Sanger Depot Museum', 'Centennial Park', 'Blossom Trail']
      },
      {
        slug: 'fowler',
        name: 'Fowler',
        title: 'Pet Insurance Fowler CA - Small Town Pet Coverage',
        landmarks: ['Fowler Park', 'Historic Downtown', 'Dry Creek Regional Park']
      }
    ]
  },
  'long-beach': {
    name: 'Long Beach',
    state: 'CA',
    title: 'Pet Insurance Long Beach CA - Port City Pet Coverage',
    metaDescription: 'Pet insurance in Long Beach, CA. Nationwide coverage for coastal pets. Serving Signal Hill, Lakewood, Cerritos & all Long Beach area.',
    landmarks: ['Queen Mary', 'Aquarium of the Pacific', 'Long Beach Harbor', 'Belmont Shore', 'Rainbow Harbor'],
    veterinaryClinics: ['VCA Long Beach Animal Hospital', 'Pet Emergency & Specialty Center', 'Advanced Critical Care'],
    averageCosts: {
      dog: 72,
      cat: 43,
      exotic: 53
    },
    subCities: [
      {
        slug: 'signal-hill',
        name: 'Signal Hill',
        title: 'Pet Insurance Signal Hill CA - Hilltop Pet Protection',
        landmarks: ['Signal Hill Park', 'Discovery Well Park', 'Hilltop Park']
      },
      {
        slug: 'lakewood',
        name: 'Lakewood',
        title: 'Pet Insurance Lakewood CA - Suburban Pet Care',
        landmarks: ['Lakewood Country Club', 'Mayfair Park', 'Pan American Park']
      },
      {
        slug: 'cerritos',
        name: 'Cerritos',
        title: 'Pet Insurance Cerritos CA - Gateway Cities Pet Coverage',
        landmarks: ['Cerritos Center', 'Heritage Park', 'Cerritos Library']
      },
      {
        slug: 'bellflower',
        name: 'Bellflower',
        title: 'Pet Insurance Bellflower CA - Southeast LA Pet Protection',
        landmarks: ['Thompson Park', 'Caruthers Park', 'Bellflower Boulevard']
      },
      {
        slug: 'paramount',
        name: 'Paramount',
        title: 'Pet Insurance Paramount CA - Gateway City Pet Care',
        landmarks: ['Paramount Park', 'Progress Park', 'Zamora Park']
      },
      {
        slug: 'hawaiian-gardens',
        name: 'Hawaiian Gardens',
        title: 'Pet Insurance Hawaiian Gardens CA - Small City Pet Coverage',
        landmarks: ['Hawaiian Gardens Casino', 'Fedde Middle School Park', 'Community Center']
      }
    ]
  },
  'oakland': {
    name: 'Oakland',
    state: 'CA',
    title: 'Pet Insurance Oakland CA - East Bay Pet Coverage',
    metaDescription: 'Pet insurance in Oakland, CA. Nationwide coverage for East Bay pets. Serving Berkeley, Alameda, Piedmont & all Alameda County.',
    landmarks: ['Lake Merritt', 'Jack London Square', 'Oakland Museum', 'Redwood Regional Park', 'Oakland Coliseum'],
    veterinaryClinics: ['VCA Bay Area Veterinary Specialists', 'Pet Emergency Treatment Service East Bay', 'Adobe Animal Hospital'],
    averageCosts: {
      dog: 78,
      cat: 47,
      exotic: 58
    },
    subCities: [
      {
        slug: 'berkeley',
        name: 'Berkeley',
        title: 'Pet Insurance Berkeley CA - University City Pet Protection',
        landmarks: ['UC Berkeley Campus', 'Telegraph Avenue', 'Berkeley Marina']
      },
      {
        slug: 'alameda',
        name: 'Alameda',
        title: 'Pet Insurance Alameda CA - Island City Pet Care',
        landmarks: ['Alameda Beach', 'USS Hornet Museum', 'Crown Memorial State Beach']
      },
      {
        slug: 'piedmont',
        name: 'Piedmont',
        title: 'Pet Insurance Piedmont CA - Hills Pet Coverage',
        landmarks: ['Piedmont Park', 'Mountain View Cemetery', 'Blair Park']
      },
      {
        slug: 'emeryville',
        name: 'Emeryville',
        title: 'Pet Insurance Emeryville CA - Bay Bridge Pet Protection',
        landmarks: ['Bay Street Shopping', 'Emeryville Marina', 'Doyle Street']
      },
      {
        slug: 'san-leandro',
        name: 'San Leandro',
        title: 'Pet Insurance San Leandro CA - East Bay Pet Care',
        landmarks: ['San Leandro Marina', 'Chabot Regional Park', 'Casa Peralta']
      },
      {
        slug: 'albany',
        name: 'Albany',
        title: 'Pet Insurance Albany CA - East Bay Hills Pet Coverage',
        landmarks: ['Albany Hill', 'Golden Gate Fields', 'Albany Beach']
      }
    ]
  },
  'bakersfield': {
    name: 'Bakersfield',
    state: 'CA',
    title: 'Pet Insurance Bakersfield CA - Kern County Pet Coverage',
    metaDescription: 'Pet insurance in Bakersfield, CA. Nationwide coverage for Central Valley pets. Serving Delano, Wasco, Shafter & all Kern County.',
    landmarks: ['Kern County Museum', 'California Living Museum', 'Hart Memorial Park', 'Buck Owens Crystal Palace', 'Panorama Bluffs'],
    veterinaryClinics: ['VCA Bakersfield Veterinary Hospital', 'Pet Emergency Treatment Services', 'Animal Medical Center'],
    averageCosts: {
      dog: 52,
      cat: 30,
      exotic: 38
    },
    subCities: [
      {
        slug: 'delano',
        name: 'Delano',
        title: 'Pet Insurance Delano CA - Farm Country Pet Protection',
        landmarks: ['Delano Regional Sports Complex', 'Cecil Park', 'Memorial Park']
      },
      {
        slug: 'wasco',
        name: 'Wasco',
        title: 'Pet Insurance Wasco CA - Rose Festival Pet Care',
        landmarks: ['Wasco Museum', 'Barker Park', 'Wasco Recreation Center']
      },
      {
        slug: 'shafter',
        name: 'Shafter',
        title: 'Pet Insurance Shafter CA - Agricultural Pet Coverage',
        landmarks: ['Shafter Depot Museum', 'Mannel Park', 'Veterans Park']
      },
      {
        slug: 'arvin',
        name: 'Arvin',
        title: 'Pet Insurance Arvin CA - Tehachapi Foothills Pet Protection',
        landmarks: ['Arvin Park', 'Bear Mountain Boulevard', 'Veterans Memorial']
      },
      {
        slug: 'lamont',
        name: 'Lamont',
        title: 'Pet Insurance Lamont CA - Rural Pet Care',
        landmarks: ['Lamont Park', 'Sunset Park', 'Community Center']
      },
      {
        slug: 'taft',
        name: 'Taft',
        title: 'Pet Insurance Taft CA - Oil Country Pet Coverage',
        landmarks: ['West Kern Oil Museum', 'Taft Park', 'Hillcrest Cemetery']
      }
    ]
  },
  'anaheim': {
    name: 'Anaheim',
    state: 'CA',
    title: 'Pet Insurance Anaheim CA - Orange County Pet Coverage',
    metaDescription: 'Pet insurance in Anaheim, CA. Nationwide coverage for OC pets. Serving Garden Grove, Orange, Fullerton & all Orange County.',
    landmarks: ['Disneyland Resort', 'Angel Stadium', 'Anaheim Convention Center', 'Knott\'s Berry Farm', 'Downtown Disney'],
    veterinaryClinics: ['VCA West Coast Specialty and Emergency Animal Hospital', 'Pet Emergency & Specialty Center', 'Advanced Critical Care'],
    averageCosts: {
      dog: 74,
      cat: 44,
      exotic: 54
    },
    subCities: [
      {
        slug: 'garden-grove',
        name: 'Garden Grove',
        title: 'Pet Insurance Garden Grove CA - Central OC Pet Protection',
        landmarks: ['Garden Grove Park', 'Christ Cathedral', 'Atlantis Play Center']
      },
      {
        slug: 'orange',
        name: 'Orange',
        title: 'Pet Insurance Orange CA - Old Towne Pet Care',
        landmarks: ['Old Towne Orange', 'Chapman University', 'Santiago Oaks Regional Park']
      },
      {
        slug: 'fullerton',
        name: 'Fullerton',
        title: 'Pet Insurance Fullerton CA - North OC Pet Coverage',
        landmarks: ['Fullerton Arboretum', 'Muckenthaler Cultural Center', 'Hillcrest Park']
      },
      {
        slug: 'buena-park',
        name: 'Buena Park',
        title: 'Pet Insurance Buena Park CA - Entertainment Pet Protection',
        landmarks: ['Knott\'s Berry Farm', 'Medieval Times', 'Ralph B. Clark Regional Park']
      },
      {
        slug: 'placentia',
        name: 'Placentia',
        title: 'Pet Insurance Placentia CA - Pleasant Place Pet Care',
        landmarks: ['Placentia-Linda Hospital', 'Kraemer Memorial Park', 'Bradford House']
      },
      {
        slug: 'stanton',
        name: 'Stanton',
        title: 'Pet Insurance Stanton CA - Small City Pet Coverage',
        landmarks: ['Stanton Central Park', 'Stanton Community Services', 'Adventure City']
      }
    ]
  },
  'santa-ana': {
    name: 'Santa Ana',
    state: 'CA',
    title: 'Pet Insurance Santa Ana CA - Orange County Seat Pet Coverage',
    metaDescription: 'Pet insurance in Santa Ana, CA. Nationwide coverage for central OC pets. Serving Costa Mesa, Irvine, Tustin & all Orange County.',
    landmarks: ['Santa Ana Zoo', 'Bowers Museum', 'Discovery Cube', 'Artists Village', 'Heritage Museum'],
    veterinaryClinics: ['VCA Orange County Veterinary Specialists', 'Pet Emergency & Specialty Center of Orange County', 'Animal Medical Center'],
    averageCosts: {
      dog: 73,
      cat: 43,
      exotic: 53
    },
    subCities: [
      {
        slug: 'costa-mesa',
        name: 'Costa Mesa',
        title: 'Pet Insurance Costa Mesa CA - Arts & Culture Pet Protection',
        landmarks: ['South Coast Plaza', 'Segerstrom Center', 'Newport Beach']
      },
      {
        slug: 'irvine',
        name: 'Irvine',
        title: 'Pet Insurance Irvine CA - Planned City Pet Care',
        landmarks: ['UC Irvine Campus', 'Irvine Spectrum', 'William R. Mason Regional Park']
      },
      {
        slug: 'tustin',
        name: 'Tustin',
        title: 'Pet Insurance Tustin CA - Foothill Ranch Pet Coverage',
        landmarks: ['Tustin Market Place', 'Peters Canyon Regional Park', 'Historic Old Town']
      },
      {
        slug: 'fountain-valley',
        name: 'Fountain Valley',
        title: 'Pet Insurance Fountain Valley CA - Suburban Pet Protection',
        landmarks: ['Mile Square Regional Park', 'Fountain Valley Sports Complex', 'Kazuma Lake']
      },
      {
        slug: 'huntington-beach',
        name: 'Huntington Beach',
        title: 'Pet Insurance Huntington Beach CA - Surf City Pet Care',
        landmarks: ['Huntington Pier', 'Bolsa Chica State Beach', 'Main Street']
      },
      {
        slug: 'newport-beach',
        name: 'Newport Beach',
        title: 'Pet Insurance Newport Beach CA - Coastal Luxury Pet Coverage',
        landmarks: ['Balboa Peninsula', 'Fashion Island', 'Newport Harbor']
      }
    ]
  },
  'stockton': {
    name: 'Stockton',
    state: 'CA',
    title: 'Pet Insurance Stockton CA - San Joaquin County Pet Coverage',
    metaDescription: 'Pet insurance in Stockton, CA. Nationwide coverage for Central Valley pets. Serving Lodi, Tracy, Manteca & all San Joaquin County.',
    landmarks: ['Haggin Museum', 'University of the Pacific', 'Oak Grove Regional Park', 'Downtown Stockton Marina', 'Pixie Woods'],
    veterinaryClinics: ['VCA Stockton Animal Hospital', 'Pet Emergency Treatment Services', 'Animal Medical Center'],
    averageCosts: {
      dog: 58,
      cat: 34,
      exotic: 42
    },
    subCities: [
      {
        slug: 'lodi',
        name: 'Lodi',
        title: 'Pet Insurance Lodi CA - Wine Country Pet Protection',
        landmarks: ['Lodi Lake Park', 'Wine & Roses Hotel', 'Hutchins Street Square']
      },
      {
        slug: 'tracy',
        name: 'Tracy',
        title: 'Pet Insurance Tracy CA - Mountain House Pet Care',
        landmarks: ['Tracy Historical Museum', 'Ellis Lake', 'West Valley Mall']
      },
      {
        slug: 'manteca',
        name: 'Manteca',
        title: 'Pet Insurance Manteca CA - Family City Pet Coverage',
        landmarks: ['Woodward Reservoir', 'Big League Dreams', 'Manteca Historical Museum']
      },
      {
        slug: 'ripon',
        name: 'Ripon',
        title: 'Pet Insurance Ripon CA - Almond City Pet Protection',
        landmarks: ['Ripon City Park', 'Caswell Memorial State Park', 'Historic Downtown']
      },
      {
        slug: 'escalon',
        name: 'Escalon',
        title: 'Pet Insurance Escalon CA - Agricultural Pet Care',
        landmarks: ['Escalon Community Park', 'Historic Downtown', 'Stanislaus River']
      },
      {
        slug: 'lathrop',
        name: 'Lathrop',
        title: 'Pet Insurance Lathrop CA - River Islands Pet Coverage',
        landmarks: ['Lathrop Community Park', 'River Islands', 'Mossdale Regional Park']
      }
    ]
  }
};

export const getAllCityPages = () => {
  const pages = [];
  
  // Add main city pages
  Object.entries(californiaLocations).forEach(([slug, city]) => {
    pages.push({
      slug,
      type: 'city',
      ...city
    });
    
    // Add subcity pages
    city.subCities.forEach(subCity => {
      pages.push({
        slug: `${slug}/${subCity.slug}`,
        type: 'subcity',
        parentCity: city,
        ...subCity
      });
    });
  });
  
  return pages;
};

export default californiaLocations;